const PRODUCT_PAGES = {
  'claim-estimation': {
    name: 'Claim Estimation Software',
    applicationSubCategory: 'Insurance Claims Automation Software',
    description:
      'AI-powered claim estimation software that automates vehicle damage assessment and repair cost calculation for faster insurance claims processing.',
    featureList: [
      'Automates vehicle repair cost estimation using AI',
      'Speeds up insurance claim estimation and processing',
      'Reduces manual errors in damage cost assessment',
      'Integrates AI claim estimation into insurance workflows',
    ],
    audience: 'Insurance Companies, Claims Teams',
  },

  'damage-detection': {
    name: 'Vehicle Damage Detection',
    applicationSubCategory: 'Vehicle Inspection Software',
    description:
      'AI-powered vehicle damage detection software that identifies dents, scratches, and structural damage from photos with high accuracy.',
    featureList: [
      'Detects vehicle dents and scratches using AI technology',
      'Identifies structural vehicle damage from images',
      'Automates vehicle inspection reports for insurers and fleets',
      'Improves accuracy in AI-based vehicle damage detection',
    ],
    audience: 'Insurance Companies, Fleet Operators',
  },

  'fraud-detection': {
    name: 'Fraud Detection Software',
    applicationSubCategory: 'Insurance Fraud Detection Software',
    description:
      'AI-based fraud detection software that identifies manipulated images, duplicate claims, and suspicious vehicle inspection patterns.',
    featureList: [
      'Detects fraudulent vehicle claims using AI analysis',
      'Identifies image tampering and manipulation in inspections',
      'Flags duplicate or suspicious insurance claims',
      'Enhances fraud detection in vehicle inspection workflows',
    ],
    audience: 'Insurance Companies, Claims Teams',
  },
  'photo-video-capture': {
    name: 'Photo & Video Capture',
    applicationSubCategory: 'Vehicle Inspection Capture Software',
    description:
      'AI-powered photo and video capture tool for structured vehicle inspections with guided workflows and real-time validation.',
    featureList: [
      'Photo inspection for car insurance workflows',
      'Provides vehicle images API for inspection processes',
      'Validates images in real-time during vehicle inspections',
      'Supports mobile-based vehicle inspection workflows',
    ],
    audience: 'Insurance Companies, Inspection Teams, Fleet Operators',
  },

  'photo-quality': {
    name: 'Photo Quality Analysis',
    applicationSubCategory: 'Image Quality Assessment Software',
    description:
      'AI image quality analysis software that ensures vehicle inspection photos meet required standards for accurate damage detection.',
    featureList: [
      'Analyzes vehicle inspection image quality using AI',
      'Detects blurry or low-quality inspection photos',
      'Ensures proper lighting and angles for inspections',
      'Improves accuracy of AI vehicle damage detection',
    ],
    audience: 'Insurance Companies, Inspection Teams',
  },

  'vehicle-damage-scanners': {
    name: 'Vehicle Damage Scanner',
    applicationSubCategory: 'Vehicle Damage Assessment Software',
    description:
      'AI-powered vehicle damage scanner that analyzes images to detect dents, scratches, and structural issues with high accuracy.',
    featureList: [
      'Scans vehicles for damage using AI image analysis',
      'Detects dents, scratches, and visible vehicle issues',
      'Generates automated car damage assessment reports',
      'Improves speed of AI-based vehicle damage scanning',
    ],
    audience: 'Insurance Companies, Fleet Operators, Automotive Businesses',
  },

  'ai-powered-ocr': {
    name: 'AI-Powered OCR Software',
    applicationSubCategory: 'Document Processing Software',
    description:
      'AI-powered OCR software that extracts data from vehicle documents, registration papers, and insurance forms with high accuracy.',
    featureList: [
      'Extracts data from vehicle documents using AI OCR',
      'Automates document processing for insurance workflows',
      'Supports multiple vehicle document formats',
      'Improves accuracy in AI-based document data extraction',
    ],
    audience: 'Insurance Companies, Claims Teams, Automotive Businesses',
  },
};

const SERVICE_PAGES = {
  insurance: {
    pageName: 'AI Vehicle Inspection for Insurance Industry',
    description:
      'AI-powered vehicle inspection solutions for insurance companies to automate claims processing, detect damage, and reduce fraud.',

    about: {
      '@type': 'Thing',
      name: 'AI vehicle inspection for insurance',
    },

    keywords: [
      'AI vehicle inspection for insurance',
      'insurance claims automation',
      'vehicle damage detection',
      'AI insurance inspection software',
      'vehicle inspection for insurance companies',
    ],

    serviceName: 'AI Insurance Inspection Solution by Inspektlabs',

    serviceDescription:
      'Inspektlabs provides AI-powered vehicle inspection software for insurance companies to automate damage detection, FNOL, and claims processing, improving speed, accuracy, and fraud detection.',

    serviceType: 'Insurance Inspection Automation',

    audience: 'Insurance Companies',

    serviceOutput:
      'Automated damage reports, claim estimates, and fraud detection insights',


  },

  'car-rental': {
    pageName: 'AI Vehicle Inspection for Car Rental Companies',

    description:
      'Automate check-in and check-out vehicle inspections with AI-powered damage detection and condition reporting.',

    about: {
      '@type': 'Thing',
      name: 'car rental inspection software',
    },

    serviceName: 'AI Car Rental Inspection Software by Inspektlabs',

    serviceDescription:
      'AI-powered vehicle inspection software for rental and leasing companies to automate check-in/check-out inspections, reduce disputes, and improve operational efficiency.',

    serviceType: 'Car Rental Inspection Software',

    audience: 'Car Rental and Leasing Companies',

    serviceOutput:
      'Automated vehicle condition reports and damage comparison insights',
  },
  'vehicle-remarketing': {
  pageName: 'AI Vehicle Inspection for Remarketing and Used Car Sales',

  description:
    'AI-powered vehicle inspection solutions to generate accurate condition reports, increase resale value, and build buyer trust.',

  about: {
    '@type': 'Thing',
    name: 'vehicle remarketing inspection software by Inspektlabs',
  },

  serviceName: 'AI Vehicle Remarketing Inspection Solution',

  serviceDescription:
    'AI-powered vehicle inspection software for remarketing companies, dealerships, and marketplaces to automate condition reporting, improve transparency, and accelerate vehicle sales.',

  serviceType: 'Vehicle Remarketing Inspection Software by Inspektlabs',

  audience: 'Dealers, Marketplaces, and Remarketing Companies',

  serviceOutput:
    'AI-generated vehicle condition reports and pricing insights',
},

'fleet-management': {
  pageName: 'AI Fleet Inspection and Management Software',

  description:
    'AI-powered fleet inspection software to track vehicle condition, reduce downtime, and automate maintenance workflows.',

  about: {
    '@type': 'Thing',
    name: 'AI fleet inspection software by Inspektlabs',
  },

  serviceName: 'AI Fleet Inspection Software by Inspektlabs',

  serviceDescription:
    'AI-powered fleet inspection solution to automate vehicle condition tracking, detect damage, and optimize maintenance operations for fleet operators.',

  serviceType: 'Fleet Inspection Software',

  audience: 'Fleet Operators and Logistics Companies',

  serviceOutput:
    'Digital inspection reports and fleet condition tracking insights',
},

'truck-inspections': {
  pageName: 'AI Truck Inspection Software for Commercial Fleets',

  description:
    'AI-powered truck inspection software that detects damage on 100+ truck parts in under 90 seconds for logistics, construction, and delivery fleets.',

  about: {
    '@type': 'Thing',
    name: 'AI truck inspection software by Inspektlabs',
  },

  serviceName: 'AI Truck Inspection Solution by Inspektlabs',

  serviceDescription:
    'AI-powered commercial vehicle inspection software that automates truck condition assessments, detects part-wise damage, and generates standardized reports for fleet operators.',

  serviceType: 'Truck Inspection Software',

  audience: 'Logistics, Construction, and Delivery Fleet Operators',

  serviceOutput:
    'Standardized truck condition reports and part-wise damage detection insights',
},

'motorcycle-inspection-software': {
  pageName: 'AI Motorcycle Inspection Software for Fleets and Dealerships',
  description:
    'AI-powered motorcycle inspection software for fleets and dealerships to automate condition reporting and improve transparency.',
  about: {
    '@type': 'Thing',
    name: 'AI motorcycle inspection software by Inspektlabs',
  },
  serviceName: 'AI Motorcycle Inspection Software by Inspektlabs',
  serviceDescription:
    'AI-powered motorcycle inspection solution to automate condition assessments, detect damage, and generate standardized reports for fleet operators and dealerships.',
  serviceType: 'Motorcycle Inspection Software',
  audience: 'Fleet Operators and Dealerships',
  serviceOutput:
    'Standardized motorcycle condition reports and damage detection insights',
},

automotive: {
  pageName: 'AI Vehicle Inspection for Automotive Industry',

  description:
    'AI-powered vehicle inspection solutions for automotive players including leasing, logistics, dealers, and repair networks.',

  about: {
    '@type': 'Thing',
    name: 'AI vehicle inspection for automotive industry',
  },

  serviceName: 'AI Automotive Inspection Solution by Inspektlabs',

  serviceDescription:
    'AI-powered vehicle inspection software for automotive companies to automate damage detection, vehicle assessments, and condition reporting across leasing, logistics, and dealerships.',

  serviceType: 'Automotive Inspection Software',

  audience: 'Automotive Companies',

  serviceOutput:
    'Automated vehicle condition reports and damage detection insights',
},
};
  
  export function getSlugFromUrl(url) {
    try {
      const pathname = new URL(url).pathname.replace(/\/$/, '');
      return pathname ? pathname.slice(1) : 'index';
    } catch {
      return null;
    }
  }
  

  
  export function buildProductSchema({
    name,
    description,
    url,
    applicationSubCategory,
    featureList,
    audience,
  }) {
    return {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'SoftwareApplication',
          '@id': `${url}#application`,
          name,
          applicationCategory: 'BusinessApplication',
          applicationSubCategory,
          operatingSystem: 'Web, iOS, Android',
          softwareVersion: 'Latest',
          url,
          mainEntityOfPage: url,
          description,
          featureList,
  
          offers: {
            '@type': 'Offer',
            url: 'https://inspektlabs.com/contact-us',
            price: '0',
            priceCurrency: 'USD',
            availability: 'https://schema.org/InStock',
            category: 'FreeTrial',
            description:
              'Includes 100 free vehicle inspections during trial period',
          },
  
          publisher: {
            '@id': 'https://inspektlabs.com/#organization',
          },
  
          brand: {
            '@id': 'https://inspektlabs.com/#organization',
          },
  
          applicationSuite: 'Inspektlabs AI Inspection Platform',
  
          audience: {
            '@type': 'Audience',
            audienceType: audience,
          },
        },
      ],
    };
  }

  export function buildServiceSchema({ url, config }) {
    const service = {
      '@type': 'Service',
      '@id': `${url}#service`,
      name: config.serviceName,
      description: config.serviceDescription,
  
      provider: {
        '@id': 'https://inspektlabs.com/#organization',
      },
  
      areaServed: {
        '@type': 'Place',
        name: 'Global',
      },
  
      serviceType: config.serviceType,
  
      audience: {
        '@type': 'Audience',
        audienceType: config.audience,
      },
  
      serviceOutput: config.serviceOutput,
  
      isRelatedTo: {
        '@id': 'https://inspektlabs.com/#platform',
      },
    };
  
    if (config.serviceSubtype) {
      service.serviceSubtype = config.serviceSubtype;
    }
  
    if (config.catalogName && config.features?.length) {
      service.hasOfferCatalog = {
        '@type': 'OfferCatalog',
        name: config.catalogName,
  
        itemListElement: config.features.map((feature) => ({
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: feature,
          },
        })),
      };
    }
  
    return {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': `${url}#webpage`,
          url,
          name: config.pageName,
          description: config.description,
  
          isPartOf: {
            '@id': 'https://inspektlabs.com/#website',
          },
  
          about: config.about,
  
          ...(config.keywords && {
            keywords: config.keywords,
          }),
  
          mainEntity: {
            '@id': `${url}#service`,
          },
        },
  
        service,
      ],
    };
  }
  
  export function getSchema({ url }) {
    const slug = getSlugFromUrl(url);
  
    if (!slug) return null;

    if (slug in PRODUCT_PAGES) {
      const config = PRODUCT_PAGES[slug];
  
      return buildProductSchema({
        ...config,
        url,
      });
    }
  
    if (slug in SERVICE_PAGES) {
      return buildServiceSchema({
        url,
        config: SERVICE_PAGES[slug],
      });
    }
  
    return null;
  }